import $ from 'jquery';
import utilities from './utilities';

$(async () => {
    $('#copy-job-id').on('click', function () {
        utilities.copyToClipboard("#copy-job-id");
    });
});
